import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Divider, Menu, MenuItem } from '@mui/material'

import { removeToken, resetIdentity, resolveAttachmentUrl } from '../../core'
import { AvatarButton, AvatarMenuHead } from './mobile-styled'

// Аватарка человека в верхней панели на каждой странице: имя, роль, парк,
// настройки и выход. Раньше всё это пряталось в низу экрана «Главная»
const MobileAvatar = () => {
  const navigate = useNavigate()
  const currentUser = useSelector((state) => state.users.currentUser)
  const roleName = useSelector((state) => state.capabilities.role?.name)
  const companyName = useSelector((state) => state.companies.selected_company?.name)
  const [anchor, setAnchor] = useState(null)

  if (!currentUser) return null

  const hasName = currentUser.first_name && currentUser.last_name
  const initials = hasName ? `${currentUser.first_name[0]}${currentUser.last_name[0]}` : (currentUser.email || '?')[0]
  const displayName = hasName ? `${currentUser.first_name} ${currentUser.last_name}` : currentUser.email

  const logout = () => {
    removeToken()
    resetIdentity()
    navigate('/')
  }

  return (
    <>
      <AvatarButton type="button" aria-label="Профиль" onClick={(event) => setAnchor(event.currentTarget)}>
        {currentUser.avatar?.url ? <img src={resolveAttachmentUrl(currentUser.avatar.url)} alt="" /> : initials}
      </AvatarButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <AvatarMenuHead>
          <strong>{displayName}</strong>
          {roleName && <span>{roleName}</span>}
          {companyName && <span>{companyName}</span>}
        </AvatarMenuHead>
        <Divider />
        <MenuItem onClick={() => { setAnchor(null); navigate('/settings') }}>Настройки</MenuItem>
        <MenuItem onClick={logout} sx={{ color: '#C53434' }}>Выйти</MenuItem>
      </Menu>
    </>
  )
}

export default MobileAvatar
